import * as angular from 'angular';
import { FileService } from 'app/_services/file.service';

(function () {
    'use strict';

    angular.module('app').directive('pkpRemitReporting', pkpRemitReporting);

    /**
     * @author frbomke.prv
     * @ngInject
     */
    function pkpRemitReporting(
        TradeProposals,
        SecondaryTrade,
        ExternalTrade,
        DATES,
        fileService: FileService
    ) {
        return {
            restrict: 'E',
            scope: {
                proposalId: '=?',
                tradeId: '=?',
                externalTradeId: '=?',
                isTrade: '=?'
            },
            link: link,
            template: require('app/_directives/pkp-remit-reporting.directive.html')
        };

        function link(scope) {
            scope.DATES = DATES;
            //scope.channelType = 'ASC';
            scope.fetchAcerSubmissions = fetchAcerSubmissions;
            scope.channelTypes = [
                { type: 'ACER', description: 'Direct submission to ACER' },
                {
                    type: 'ASC',
                    description: 'Automated shipper connection channel'
                },
                { type: 'EMAIL', description: 'EMail channel' }
            ];
            scope.downloadReport = downloadReport;

            var noDataChannels = [];

            scope.uiLoading = true;

            probeSubmissions(scope.channelTypes);

            function fetchAcerSubmissions(channelType, hasResultsInScope) {
                scope.uiLoading = true;
                var params: any = {
                    channelType: channelType
                };

                if (angular.isDefined(scope.externalTradeId)) {
                    params.id = scope.externalTradeId;
                    return ExternalTrade.acerSubmissions(
                        params,
                        onSuccess,
                        onError
                    ).$promise.finally(onFinally);
                } else {
                    if (!scope.isTrade) {
                        params.proposalId = scope.proposalId;
                        return TradeProposals.acerSubmissions(
                            params,
                            onSuccess,
                            onError
                        ).$promise.finally(onFinally);
                    } else {
                        params.tradeId = scope.tradeId;
                        return SecondaryTrade.acerSubmissions(
                            params,
                            onSuccess,
                            onError
                        ).$promise.finally(onFinally);
                    }
                }

                function onSuccess(res) {
                    scope.acerReports = res;
                }

                function onError() {
                    scope.uiError = true;
                }

                function onFinally() {
                    //this should only be executed for the first channel with data
                    if (scope.acerReports.length > 0 && !hasResultsInScope) {
                        scope.hasResult = true;
                        scope.uiLoading = false;
                        scope.channelType = channelType;
                        scope.displayAcerReports = scope.acerReports;
                    }

                    //check for channel with no data & collect for cleanup
                    if (scope.acerReports.length === 0) {
                        noDataChannels.push(channelType);
                    }
                }
            }

            //Let's see which channel has some data in it...
            function probeSubmissions(channelTypes) {
                var countTypes = 0;

                function probeSubmission() {
                    if (countTypes < channelTypes.length) {
                        var hasResults = scope.hasResult;
                        fetchAcerSubmissions(
                            channelTypes[countTypes++].type,
                            hasResults
                        ).then(probeSubmission);
                    } else {
                        scope.uiLoading = false;

                        //cleanup channels object in scope
                        angular.forEach(noDataChannels, function (channel) {
                            var index = findWithAttr(
                                scope.channelTypes,
                                'type',
                                channel
                            );
                            if (index > -1) {
                                scope.channelTypes.splice(index, 1);
                            }
                        });

                        if (!scope.hasResult) {
                            scope.uiNoData = true;
                        }
                    }
                }
                probeSubmission();
            }

            //helper method to identify object in array by its attr
            function findWithAttr(array, attr, value) {
                for (var i = 0; i < array.length; i += 1) {
                    if (array[i][attr] === value) {
                        return i;
                    }
                }
            }

            function downloadReport(report: any): boolean {
                return fileService.triggerFileDownload(
                    report.acerResponse,
                    report.submissionTime + '-' + report.proposalId + '.xml',
                    'text/xml'
                );
            }
        }
    }
})();
